import { FC } from 'react';
import { SettingsLayout } from './layout';
import { SettingsApiKeysV2 } from '~/components/settings/api-keys-v2';

export const ApiKeys: FC = () => {
  return (
    <SettingsLayout containerWidth="max-w-4xl lg:max-w-4xl 2xl:max-w-6xl">
      <SettingsApiKeysV2 />
    </SettingsLayout>
  );
};
